import { Extension } from '@tiptap/core'
import { storeToRefs } from 'pinia'

import { ActionButton } from '@/components/editor'
import { useEditorStore } from '@/stores'
import type { GeneralOptions } from '@/types'

export type FullscreenOptions = GeneralOptions<FullscreenOptions>

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fullscreen: {
      setFullscreen: () => ReturnType
    }
  }
}

export const Fullscreen = Extension.create<FullscreenOptions>({
  name: 'fullscreen',
  addOptions() {
    return {
      ...this.parent?.(),
      button: ({ editor }) => {
        const editorStore = useEditorStore()
        const { isFullscreen } = storeToRefs(editorStore)
        return {
          component: ActionButton,
          componentProps: {
            tooltip: isFullscreen.value ? 'Exit' : 'Fullscreen',
            action: () => editor?.chain().setFullscreen().focus().run(),
            icon: isFullscreen.value ? 'Minimize' : 'Maximize',
            isActive: () => isFullscreen.value,
          },
        }
      },
    }
  },
  addCommands() {
    return {
      setFullscreen: () => () => {
        const editorStore = useEditorStore()
        editorStore.toggleFullscreen()
        return true
      },
    }
  },
  addKeyboardShortcuts() {
    const editorStore = useEditorStore()

    return {
      F11: () => {
        editorStore.toggleFullscreen()
        return true
      },
      'Mod-F11': () => {
        editorStore.toggleFullscreen()
        return true
      },
    }
  },
})
